import { request, requestWithMsg, MsgResult } from './request';

/** 方案类型 (独立表 plan_type): 参数 params.planType 的取值来源, 按工艺架构分, 并可绑定到具体设备. */
export interface PlanType {
    id: number;
    archCode: string;
    code: string;
    label: string;
    sort: number;
    isEnabled: boolean;
    /** 设备绑定: 空 = 该架构内全部设备, 非空 = 只在列出的设备上可选 */
    deviceKeys?: string[] | null;
    updatedAt?: number;
}

const BASE = '/v1';

/** 方案类型列表. archCode 空 = 全部架构; includeDisabled 仅维护页要 (下拉只用启用项). */
export function listPlanTypes(
    opts: { archCode?: string; includeDisabled?: boolean } = {},
): Promise<PlanType[]> {
    return request<PlanType[]>(`${BASE}/plan-types`, {
        query: {
            archCode: opts.archCode || undefined,
            includeDisabled: opts.includeDisabled ? 'true' : undefined,
        },
        dedupe: true,
    });
}

// 写接口: 统一走审批流 (message 含"已提交审批", data={taskCode}).
export function createPlanType(payload: {
    archCode: string;
    code: string;
    label: string;
    sort?: number;
    isEnabled?: boolean;
    deviceKeys?: string[];
}): Promise<MsgResult<{ id?: number; taskCode?: string }>> {
    return requestWithMsg(`${BASE}/plan-types`, {
        method: 'POST',
        body: payload,
    });
}

/** 编辑方案类型; 业务键 (archCode, code) 不可改. deviceKeys 传 [] = 清空绑定 (恢复架构内全部设备), 不传 = 不动. */
export function updatePlanType(
    archCode: string,
    code: string,
    payload: {
        label?: string;
        sort?: number;
        isEnabled?: boolean;
        deviceKeys?: string[];
    },
): Promise<MsgResult<{ taskCode?: string } | null>> {
    return requestWithMsg(`${BASE}/plan-types/update`, {
        method: 'POST',
        body: { archCode, code, ...payload },
    });
}

export function deletePlanType(
    archCode: string,
    code: string,
): Promise<MsgResult<{ taskCode?: string } | null>> {
    return requestWithMsg(`${BASE}/plan-types/delete`, {
        method: 'POST',
        body: { archCode, code },
    });
}

/** 是否适用于某设备: 没绑定设备 = 适用架构内全部设备; 没传设备 (还没选型号) 时只留没绑定的通用项. */
export function planTypeAppliesTo(
    p: Pick<PlanType, 'deviceKeys'>,
    deviceKey: string,
): boolean {
    return (
        !p.deviceKeys?.length ||
        (!!deviceKey && p.deviceKeys.includes(deviceKey))
    );
}
